<!-- cartas-->

<!-- <p-growl [life]="5000" [sticky]="false" [(value)]="messages">
</p-growl> -->
<p-toast [life]="3000" [sticky]="false"></p-toast>

<div class="form-horizontal row" *ngIf="opcion!=4 && opcion!=5">

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Name of patient' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="namepatient" value="namepatient" name="namepatient"
        required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Identification number' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="identificationnumber" value="identificationnumber"
        name="identificationnumber" required>
    </textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Category' | translate }}:</label>
    <div class="col-md-12">
      <input type = "text" class="form-control"
          [(ngModel)]="Category" name="category" disabled="true">   
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Sub Category' | translate }}:</label>
    <div class="col-md-12">
      <input type = "text" class="form-control"
          [(ngModel)]="SubCategory" name="subcategory" disabled="true">   
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Coordinated by' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="agente" value="agente" name="agente" required>
      </textarea>
    </div>
  </div>


  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Phone' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="tel" value="tel" name="tel" required>
    </textarea>
    </div>
  </div>

  <!-- <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Coordinated by' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="coordinatedby" name="coordinatedby" required>
</textarea>
    </div>
  </div> -->

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Day and hour' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="daynhour" name="daynhour" required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9">{{ 'Branch office' | translate }}:</label>
    <div class="col-md-12">
      <input type="text" class="form-control"
      [(ngModel)]="branch" name="branch" required />
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Address' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="direccion" value="direccion" name="direccion"
        required>
</textarea>
    </div>
  </div>
  <!---
  <div class="form-group col-md-6" >
    <label class="control-label col-sm-9"> {{ 'Cost' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control"
      [(ngModel)]="cost" value="cost" name="cost" required >
    </textarea>
    </div>
  </div>


  <div class="form-group col-md-6" >
    <label class="control-label col-sm-9"> {{ 'Responsible for the payment' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control"
  [(ngModel)]="responsible" name="responsible" required >
</textarea>
    </div>
  </div> -->

  <!-- <div *ngIf="opcion !=3">

    <label class="control-label col-sm-9">
      {{ 'Cost' | translate }}:
    </label>
    <div class="col-md-12">
      <input type="text" class="form-control" [(ngModel)]="cost_" name="cost_" required>

    </div>
  </div> -->

  <div *ngIf="opcion == 3">
    <br>
    <label class="control-label col-sm-9">
      {{ 'Customer involvement' | translate }}:
    </label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="cost_" name="cost_" required>
    </textarea>
      <br>
    </div>
  </div>

  <div *ngIf="opcion !=3">

    <label class="control-label col-sm-9">
      {{ 'Responsible for the payment' | translate }}:
    </label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="responsible" name="responsible" required>
      </textarea>

    </div>
  </div>



  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Observations' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="observation" name="observation" required>
    </textarea>
    </div>
  </div>

  <div class="form-group col-md-6" *ngIf="activateemail">
    <label class="control-label col-sm-9"> {{ 'Email' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="emails" name="emails" required>
      </textarea>
    </div>
  </div>




  <!--fin cartas-->
  <div class="col-sm-offset-3 col-sm-9 div-btn-right">
    <button (click)="Enviarcartaprov()" *ngIf="activateemail" class="btn primary-btn btn primary-btn-fw">
      {{ 'Send' | translate }}
    </button>


    <button (click)="Generarcarta()" class="btn primary-btn btn primary-btn-fw">
      {{ 'Generate' | translate }}
    </button>

  </div>


</div>








<div class="form-horizontal row" *ngIf="opcion==4">
  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Client Name' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="namepatient" value="namepatient" name="namepatient"
        required>
      </textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Identification number' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="identificationnumber" value="identificationnumber"
        name="identificationnumber" required>
    </textarea>
    </div>
  </div>


  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Category' | translate }}:</label>
    <div class="col-md-12">
      <select class="form-control" [(ngModel)]="Category" name="category" (ngModelChange)="onSelectCategory($event)">

        <ng-container *ngFor="let tp of types">
          <option value={{tp.id}}>
            {{ tp.name }}
          </option>

        </ng-container>
      </select>
    </div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Sub Category' | translate }}:</label>
    <div class="col-md-12">
      <select class="form-control" [(ngModel)]="SubCategory" name="subcategory">

        <ng-container *ngFor="let sub of subtypes">
          <option *ngIf="sub.idt == id_Category" value={{sub.sub}}>
            {{ sub.sub }}
          </option>

        </ng-container>
      </select>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Asesor Call Center Asi' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="agente" value="agente" name="agente" required>
      </textarea>
    </div>
  </div>

  <!--
  <div class="form-group col-md-6" >
    <label class="control-label col-sm-9"> {{ 'Phone' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control"
      [(ngModel)]="tel" value="tel" name="tel" required >
    </textarea>
    </div>
  </div>-->

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Coordinated by (provider)' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="coordinatedby" name="coordinatedby" required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Day and hour' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="daynhour" name="daynhour" required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9">{{ 'Nombre Del Centro' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="nombre_centro" value="nombre_centro"
        name="nombre_centro" required>
    </textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9">{{ 'Especificar' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="especificar" value="especificar" name="especificar"
        required>
    </textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9">{{ 'Branch office' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="branch" value="branch" name="branch" required>
    </textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Address' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="direccion" value="direccion" name="direccion"
        required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Nombre de la mascota' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="nombre_mascota" value="nombre_mascota"
        name="nombre_mascota" required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Peso' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="peso" value="peso" name="peso" required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'edad' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="edad" value="edad" name="edad" required>
</textarea>
    </div>
  </div>

  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Raza' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="raza" value="raza" name="raza" required>
</textarea>
    </div>
  </div>
  <!---
  <div class="form-group col-md-6" >
    <label class="control-label col-sm-9"> {{ 'Cost' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control"
      [(ngModel)]="cost" value="cost" name="cost" required >
    </textarea>
    </div>
  </div>


  <div class="form-group col-md-6" >
    <label class="control-label col-sm-9"> {{ 'Responsible for the payment' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control"
  [(ngModel)]="responsible" name="responsible" required >
</textarea>
    </div>
  </div> -->







  <div class="form-group col-md-6">
    <label class="control-label col-sm-9"> {{ 'Observations' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="observation" name="observation" required>
    </textarea>
    </div>
  </div>

  <div class="form-group col-md-6" *ngIf="activateemail">
    <label class="control-label col-sm-9"> {{ 'Email' | translate }}:</label>
    <div class="col-md-12">
      <textarea rows="1" cols="10" class="form-control" [(ngModel)]="emails" name="emails" required>
      </textarea>
    </div>
  </div>




  <!--fin cartas-->
  <div class="col-sm-offset-3 col-sm-9 div-btn-right">
    <button (click)="Enviarcartaprov()" *ngIf="activateemail" class="btn primary-btn btn primary-btn-fw">
      {{ 'Send' | translate }}
    </button>


    <button (click)="Generarcarta()" class="btn primary-btn btn primary-btn-fw">
      {{ 'Generate' | translate }}
    </button>

  </div>


</div>

<form #form="ngForm">
  <div class="form-horizontal row" *ngIf="opcion==5 && buca_data">
    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Client Name' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['name']" name="namepatient" class="form-control" required>
      </div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Name of the dependent' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['dependent_name']" name="dependent_name" class="form-control">
      </div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Identification number' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['identification']" name="identificationnumber" class="form-control"
          required disabled>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Service' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['service']" name="service" class="form-control" required disabled>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Attends the service' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['dentist']" name="dentist" class="form-control" required disabled>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9">{{ 'Customer email' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['customer_email']" name="customer_email" class="form-control"
          required>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Provider email' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['provider_email']" name="provider_email" class="form-control"
          required>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Asesor' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['asesor']" name="agente" class="form-control" required>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Sub Category' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['sub_category_provider']" name="sub_category_provider"
          class="form-control" required>
      </div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Coordinator' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['coordinator']" name="coordinatedby" class="form-control" required>
      </div>
    </div>

    <div class="form-group col-md-6" *ngIf="!changeAppointmentDate">
      <label class="control-label col-sm-9"> {{ 'Appointment date' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['date']" name="date_" class="form-control" required disabled>
      </div>
    </div>

    <div class="form-group col-md-5" *ngIf="!changeAppointmentDate">
      <label class="control-label col-sm-9"> {{ 'Appointment time' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['time']" name="time_" class="form-control" required disabled>
      </div>
    </div>

    <div class="form-group col-md-1 align-content" *ngIf="!changeAppointmentDate">
      <button (click)="modifyAppointmentDate()" class="btn primary-btn btn primary-btn-fw">
        {{ 'Change' | translate }}
      </button>
    </div>

    <div class="form-group col-md-12 modify-content" *ngIf="changeAppointmentDate">
      <div class="date-content">
        <label class="control-label">
          {{'Appointment date and time' | translate}}:
        </label>
        <p-datepicker [showIcon]="true" [required]="true" name="dateControl" dateFormat="dd/mm/yy"
          [(ngModel)]="appointmentDate" [showTime]="true" hourFormat="12">
        </p-datepicker>
      </div>

      <button (click)="saveAppointmentDate()" class="btn primary-btn btn primary-btn-fw extra-padding"
        [disabled]="!appointmentDate">
        {{ 'Save' | translate }}
      </button>

      <button (click)="modifyAppointmentDate()" class="btn primary-btn btn primary-btn-fw">
        {{ 'Cancel' | translate }}
      </button>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9">{{ 'Branch office' | translate }}:</label>
      <div class="col-md-12">
        <input type="text" [(ngModel)]="buca_data['office']" name="branch" class="form-control" required disabled>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="control-label col-sm-9"> {{ 'Address' | translate }}:</label>
      <div class="col-md-12">
        <textarea rows="2" cols="10" class="form-control" [(ngModel)]="buca_data['address']" name="direccion" required>
        </textarea>
      </div>
    </div>

    <div class="form-group col-sm-6">
      <label class="control-label">{{ 'Cabin contact phones' | translate }}:</label>
      <div>
        <mat-form-field class="chip-input w-100" appearance="fill" [disabled]="true">
          <mat-chip-list #chipListCabinContactPhones>
            <mat-chip *ngFor="let chipCabinContactPhones of chipsCabinContactPhones" [selectable]="false"
              [removable]="false">
              {{chipCabinContactPhones.value}}
            </mat-chip>
            <input type="tel" [placeholder]="'Contact phone'| translate" [matChipInputFor]="chipListCabinContactPhones"
              [disabled]="true">
          </mat-chip-list>
        </mat-form-field>
      </div>
    </div>
    <div class="form-group col-sm-6">
      <label class="control-label">{{ 'Providers Cabin contact phones' | translate }}:</label>
      <div>
        <div>
          <mat-form-field class="chip-input w-100" appearance="fill" [disabled]="true">
            <mat-chip-list #chipListProvidersPhonesContactCabin>
              <mat-chip *ngFor="let chipProvidersCabinContactPhones of chipsProvidersCabinContactPhones"
                [selectable]="false" [removable]="false">
                {{chipProvidersCabinContactPhones.value}}
              </mat-chip>
              <input [placeholder]="'Contact phone'| translate" [matChipInputFor]="chipListProvidersPhonesContactCabin"
                [disabled]="true">
            </mat-chip-list>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!--fin cartas-->
    <div class="send_btn">
      <button (click)="sendConfirmationLetter()" class="btn primary-btn btn primary-btn-fw"
        [disabled]="form.form.invalid || form.form.pending || changeAppointmentDate">
        {{ 'Send' | translate }}
      </button>
      <button (click)="donwloadConfirmationLetter()" class="btn primary-btn btn primary-btn-fw"
        [disabled]="form.form.invalid || form.form.pending || changeAppointmentDate">
        {{ 'Download' | translate }}
      </button>
    </div>
  </div>
</form>